if (typeof LayerWindow === "undefined") {
  class LayerWindow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.header-section');
      this.productTips = document.querySelectorAll('.js-product-tips');
      this.toggles = this.querySelectorAll(".js-layer-toggle");
      this.selected = this.querySelector(".js-layer-selected");
      this.layer = this.querySelector(".js-layer");
      this.inputs = this.querySelectorAll("input:not([type='search']");
      this.labels = this.querySelectorAll(".js-variant-label");
      this.selects = this.querySelectorAll("select");
      this.initEvent();
      this.watchLayerState();
    }

    initEvent() {
      if (this.toggles) {
        this.toggles.forEach((toggle) => {
          toggle.addEventListener("click", this.toggleLayer.bind(this));
        })
      }

      if (this.inputs && !this.hasAttribute('cart-drawer')) {
        this.inputs.forEach((input) => {
          input.addEventListener("change", this.selectValue.bind(this, input));
        })
      }

      if (this.labels) {
        this.labels.forEach((label) => {
          label.addEventListener("click", this.selectLabel.bind(this, label));
        })
      }
    }

    toggleLayer() {
      if (!this.classList.contains("--no-index")) {
        this.header.classList.toggle("--open-layer");
      }
      this.layer.classList.toggle("--open");
      this.focusSearchInput();
    }

    // The header button opens the search layer by toggling --open itself
    // (predictive-search.js), so toggleLayer is not called in that case:
    // watching the class is the only way to catch every open and close.
    watchLayerState() {
      if (!this.classList.contains("--search")) {
        return;
      }
      this.layerWasOpen = this.layer.classList.contains("--open");
      new MutationObserver(() => {
        const isOpen = this.layer.classList.contains("--open");
        if (isOpen === this.layerWasOpen) {
          return;
        }
        this.layerWasOpen = isOpen;
        this.trackVisualViewport();
        this.focusSearchInput();
      }).observe(this.layer, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    // The mobile keyboard shrinks the visual viewport but not a fixed element,
    // so without this the bottom of the search layer sits behind the keyboard.
    trackVisualViewport() {
      if (!this.classList.contains("--search") || !window.visualViewport) {
        return;
      }
      if (!this.onViewportChange) {
        this.onViewportChange = () => {
          const viewport = window.visualViewport;
          this.style.setProperty(
            "--layer-window-visual-height",
            `${viewport.height}px`
          );
          this.style.setProperty(
            "--layer-window-visual-top",
            `${viewport.offsetTop}px`
          );
        };
      }
      if (this.layer.classList.contains("--open")) {
        this.onViewportChange();
        window.visualViewport.addEventListener("resize", this.onViewportChange);
        window.visualViewport.addEventListener("scroll", this.onViewportChange);
      } else {
        window.visualViewport.removeEventListener("resize", this.onViewportChange);
        window.visualViewport.removeEventListener("scroll", this.onViewportChange);
        this.style.removeProperty("--layer-window-visual-height");
        this.style.removeProperty("--layer-window-visual-top");
      }
    }

    focusSearchInput() {
      if (!this.layer.classList.contains("--open")) {
        return;
      }
      const searchInput = this.querySelector("input[type='search']");
      if (!searchInput) {
        return;
      }
      // autofocus only fires on page load, so focus the field every time the
      // drawer opens. The layer merely slides in via a transform, so the input
      // is already focusable; preventScroll avoids a jump while it animates.
      requestAnimationFrame(() => searchInput.focus({ preventScroll: true }));
    }

    selectValue(input) {
      if (this.selected) {
        this.selected.classList.remove("--oos");
        this.selected.classList.remove("--not-selected");
        this.selected.innerHTML = input.value;
        if (input.classList.contains("is-disabled")) {
          this.selected.classList.add("--oos");
          this.productTips.forEach((tip) => {
            tip.classList.add("hidden");
          })
        } else {
          this.productTips.forEach((tip) => {
            tip.classList.remove("hidden");
          })
        }
        this.toggleLayer();
      }
    }

    selectLabel(label) {
      const id = label.getAttribute("for");
      const input = this.querySelector(`input[id=${id}]`);
      if (input.checked) {
        const event = new Event('change');
        input.dispatchEvent(event);
      }
    }
  }

  if (!customElements.get("layer-window")) {
    customElements.define("layer-window", LayerWindow);
  }
}